import { render, staticRenderFns } from "./MenuRevision.vue?vue&type=template&id=21a083fc"
import script from "./MenuRevision.vue?vue&type=script&lang=js"
export * from "./MenuRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports